import React from 'react';
import { BookOpenIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, BanknoteIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-canvas py-10" data-id="element-70" data-mp="3ggtwodvnbb34">
      <div className="mx-auto max-w-page px-5 text-center" data-id="element-71" data-mp="32oe0nx15wdbp">
        <div className="flex items-center justify-center gap-2" data-id="element-72" data-mp="32m1bayt2r0om">
          <BookOpenIcon className="h-4 w-4 text-flame" aria-hidden="true" data-id="element-73" data-mp="36q900vzj8gmu" />
          <span className="font-display text-[17px] font-black tracking-tight text-night" data-id="element-74" data-mp="3uesclnpm7fkq">
            Librofy.Store<sup className="ml-0.5 align-super text-[9px] font-bold" data-id="element-75" data-mp="37o5ytxdtvcu">™</sup>
          </span>
        </div>
        <p className="mx-auto mt-2 max-w-sm text-[13px] leading-relaxed text-muted" data-id="element-76" data-mp="3ldaopj5yu9lh">
          Sistemas digitales simples para gente real: leelos en el celular, imprimilos y aplicalos hoy.
        </p>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-77" data-mp="29ydvdx2r0y8b">
          {[{
          icon: CreditCardIcon,
          label: 'Mercado Pago'
        }, {
          icon: CreditCardIcon,
          label: 'Tarjeta'
        }, {
          icon: BanknoteIcon,
          label: 'Transferencia'
        }, {
          icon: LockIcon,
          label: 'Pago seguro'
        }, {
          icon: ShieldCheckIcon,
          label: 'Garantía 7 días'
        }].map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 rounded-full border border-line bg-paper px-3 py-1.5 text-[11.5px] font-semibold text-teal-700" data-id="element-78" data-mp="3q7bz8ba5lhjl">
              <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-79" data-mp="32w27regl89q" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-[11px] leading-relaxed text-muted" data-id="element-80" data-mp="hriipwfto62j">
          © {new Date().getFullYear()} Librofy.Store™. Producto digital de descarga inmediata. El contenido
          es informativo y no reemplaza el consejo de un profesional de la salud.
        </p>
      </div>
    </footer>;
}